import * as jQuery from 'jquery';
import 'jquery-colorbox';

const colorboxDefaults = {
	transition: 'fade'
	, opacity: .60
	, maxWidth: '80%'
	, maxHeight: '80%'
	, fixed: true
	, close: '<span>Close</span>'
	// , onComplete: function () {
	// 	jQuery.colorbox.resize();
	// 	window.setInterval(function () {
	// 		jQuery.colorbox.resize();
	// 	}, 500);
	// }
};
const lightboxer = () => {
	const lightboxSubsection = jQuery.extend({}, colorboxDefaults, {
		initialHeight: '100'
		, rel: false
		, href: function () {
			const $this = jQuery(this);
			return $this.attr('href') + ' #' + $this.attr('data-lightboxSubsection');
		}
	});
	jQuery('a[class*="lightboxed"]').colorbox(lightboxSubsection);


	const lightboxVideo = jQuery.extend({}, colorboxDefaults, {
		iframe: true
		, rel: false
		, initialWidth: 640
		, initialHeight: 480
		, width: 640
		, height: 480
		, href: function () {
			var videoId = /[\\?&]v=([^&#]*)/.exec(this.href);
			if (videoId && videoId[1]) {
				return 'https://youtube.com/embed/' + videoId[1] + '?rel=0';
			}
		}
	});
	jQuery('a[rel="lightbox"]').colorbox(lightboxVideo);
};

export default lightboxer;
